import React, { createContext, useContext, useState } from "react";

const NavigatorState = createContext();

export const useNavigatorState = () => useContext(NavigatorState);

function NavigatorProvider({ children }) {
  const [navigateState, setNavigateState] = useState(null);

  return (
    <NavigatorState.Provider value={{ navigateState, setNavigateState }}>
      {children}
    </NavigatorState.Provider>
  );
}

export default NavigatorProvider;